/**
 * 通过 static 脚本加载 wangEditor（绕过 webpack3 无法解析 V5 现代语法的问题）
 */
let loadingPromise = null;

function publicPath() {
  // webpack 注入；开发 / ，生产 ./
  // eslint-disable-next-line camelcase, no-undef
  if (typeof __webpack_public_path__ === "string") {
    // eslint-disable-next-line camelcase, no-undef
    return __webpack_public_path__;
  }
  return "/";
}

function assetUrl(relPath) {
  const base = publicPath();
  if (base.endsWith("/")) return base + relPath;
  return base + "/" + relPath;
}

function ensureCss() {
  if (document.getElementById("wangeditor-css")) return;
  const link = document.createElement("link");
  link.id = "wangeditor-css";
  link.rel = "stylesheet";
  link.href = assetUrl("static/wangeditor/css/style.css");
  document.head.appendChild(link);
}

function getApi() {
  const api = window.wangEditor;
  if (api && typeof api.createEditor === "function") {
    return api;
  }
  return null;
}

export function loadWangEditor() {
  const existed = getApi();
  if (existed) {
    return Promise.resolve(existed);
  }
  if (loadingPromise) {
    return loadingPromise;
  }
  ensureCss();
  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = "wangeditor-js";
    script.src = assetUrl("static/wangeditor/index.js");
    script.async = true;
    script.onload = () => {
      const api = getApi();
      if (!api) {
        loadingPromise = null;
        reject(new Error("[RichEditor] wangEditor global unavailable"));
        return;
      }
      resolve(api);
    };
    script.onerror = () => {
      loadingPromise = null;
      reject(new Error("[RichEditor] failed to load wangEditor script"));
    };
    document.head.appendChild(script);
  });
  return loadingPromise;
}

export function createEditor(options) {
  const api = getApi();
  if (!api) {
    throw new Error("[RichEditor] createEditor called before loadWangEditor");
  }
  return api.createEditor(options);
}

export function createToolbar(options) {
  const api = getApi();
  if (!api) {
    throw new Error("[RichEditor] createToolbar called before loadWangEditor");
  }
  return api.createToolbar(options);
}



// WEBPACK FOOTER //
// ./src/utils/wangeditor-editor-bridge.js